import { createFileRoute, useNavigate } from "@tanstack/react-router";
import IntroductionVideo from "@/components/IntroductionVideo";

export const Route = createFileRoute("/introduction")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate({ to: "/path" });
  };

  const handleSkip = () => {
    navigate({ to: "/path" });
  };

  return <IntroductionVideo onComplete={handleComplete} onSkip={handleSkip} />;
}
